<script setup>
import { ref, computed } from 'vue';
import Icon from 'next/icon/Icon.vue';
import { useSnakeCase } from 'dashboard/composables/useTransformKeys';
import { useMessageContext } from '../provider.js';
import GalleryView from 'dashboard/components/widgets/conversation/components/GalleryView.vue';
import HiddenMediaNotice from '../HiddenMediaNotice.vue';

defineProps({
  attachment: {
    type: Object,
    required: true,
  },
});

const showGallery = ref(false);

const { filteredCurrentChatAttachments, contentAttributes } =
  useMessageContext();

// Mídia marcada como imprópria: oculta até o agente pedir para ver (só para ele).
const isRevealed = ref(false);
const hiddenMedia = computed(() => contentAttributes.value?.hiddenMedia);
const isMediaHidden = computed(() => !!hiddenMedia.value && !isRevealed.value);
</script>

<template>
  <HiddenMediaNotice
    v-if="isMediaHidden"
    compact
    :hidden-media="hiddenMedia"
    @reveal="isRevealed = true"
  />
  <div
    v-else
    class="size-[72px] overflow-hidden contain-content rounded-xl cursor-pointer relative group"
    @click="showGallery = true"
  >
    <video
      :src="attachment.dataUrl"
      class="w-full h-full object-cover"
      muted
      playsInline
    />
    <div
      class="absolute w-full h-full inset-0 p-1 flex items-center justify-center"
    >
      <div
        class="size-7 bg-n-slate-1/60 backdrop-blur-sm rounded-full overflow-hidden shadow-[0_5px_15px_rgba(0,0,0,0.4)]"
      >
        <Icon
          icon="i-teenyicons-play-small-solid"
          class="size-7 text-n-slate-12/80 backdrop-blur"
        />
      </div>
    </div>
  </div>
  <GalleryView
    v-if="showGallery && !isMediaHidden"
    v-model:show="showGallery"
    :attachment="useSnakeCase(attachment)"
    :all-attachments="filteredCurrentChatAttachments"
    @error="onError"
    @close="() => (showGallery = false)"
  />
</template>
